import { useEffect, useState } from 'react';

import { useLocation, useParams } from 'react-router-dom';

import useIntegration from 'api/useIntegration';
import useTheme from 'api/useTheme';

import { defaultCompletedTheme } from './defaults';

export const useGetCompletedInitialValues = () => {
  const location = useLocation();

  const { publisherId } = useParams();

  const [initialValues, setInitialValue] = useState<any>(defaultCompletedTheme);

  const { getCompletedTheme: completedTheme } = useTheme(publisherId);

  const { getIntegration } = useIntegration(publisherId);

  useEffect(() => {
    setInitialValue({
      purchaseCompletedModal: {
        color:
          completedTheme.data?.purchaseCompletedModal?.color ||
          defaultCompletedTheme.purchaseCompletedModal.color,
        size:
          completedTheme.data?.purchaseCompletedModal?.size ??
          defaultCompletedTheme.purchaseCompletedModal.size,
        text:
          completedTheme.data?.purchaseCompletedModal?.text ||
          defaultCompletedTheme.purchaseCompletedModal.text,
        weight:
          completedTheme.data?.purchaseCompletedModal?.weight ||
          defaultCompletedTheme.purchaseCompletedModal.weight
      },
      additionalText: {
        color:
          completedTheme.data?.additionalText?.color ||
          defaultCompletedTheme.additionalText.color,
        size:
          completedTheme.data?.additionalText?.size ??
          defaultCompletedTheme.additionalText.size,
        text:
          completedTheme.data?.additionalText?.text ||
          defaultCompletedTheme.additionalText.text,
        weight:
          completedTheme.data?.additionalText?.weight ||
          defaultCompletedTheme.additionalText.weight
      },
      productsQuantity: {
        color:
          completedTheme.data?.productsQuantity?.color ||
          defaultCompletedTheme.productsQuantity?.color,
        size:
          completedTheme.data?.productsQuantity?.size ??
          defaultCompletedTheme.productsQuantity?.size,
        weight:
          completedTheme.data?.productsQuantity?.weight ||
          defaultCompletedTheme.productsQuantity?.weight
      },
      backgroundOpacity:
        completedTheme.data?.backgroundOpacity ?? defaultCompletedTheme.backgroundOpacity,
      closeIcon: completedTheme.data?.closeIcon ?? defaultCompletedTheme.closeIcon,
      backToGameButton: {
        image:
          completedTheme.data?.backToGameButton?.image ??
          defaultCompletedTheme.backToGameButton.image,
        text:
          completedTheme.data?.backToGameButton?.text ||
          defaultCompletedTheme.backToGameButton.text
      },
      deepLinks: {
        ios:
          getIntegration.data?.deepLinks?.find(
            (platform: { platform: string; deepLink: string }) =>
              platform.platform === 'ios'
          )?.deepLink || defaultCompletedTheme.deepLinks.ios,
        android:
          getIntegration.data?.deepLinks?.find(
            (platform: { platform: string; deepLink: string }) =>
              platform.platform === 'android'
          )?.deepLink || defaultCompletedTheme.deepLinks.android,
        web:
          getIntegration.data?.deepLinks?.find(
            (platform: { platform: string; deepLink: string }) =>
              platform.platform === 'web'
          )?.deepLink || defaultCompletedTheme.deepLinks.web
      }
    });
  }, [completedTheme?.data, getIntegration.data, location]);

  return { initialValues };
};
